export interface CouponsConfig {
  apiUrl: string;
  cookieDomain?: string;
}

let config: CouponsConfig | undefined;

export function configureCoupons(c: CouponsConfig): void {
  config = c;
}

export function getCouponsConfig(): CouponsConfig {
  if (!config) {
    throw new Error(
      'configureCoupons() must be called before accessing config'
    );
  }
  return config;
}

/** Reset module level config to undefined. Used in tests to prevent state leaking between test cases. */
export function resetCouponsConfig(): void {
  config = undefined;
}
